import { useContext, useMemo } from 'react';
import { Chip } from '@mui/material';
import { AppContext } from '../all';
import { chipColors } from '../../lib/contrast';

type RestrictionType = {
    id: string;
    color: string;
    short: string;
};

type Props = {
    type: string;
};

export function SttChipRestrictionType({ type }: Props): React.ReactElement {
    const cxt = useContext(AppContext)!;

    const restType = useMemo((): RestrictionType | undefined => {
        if (!type || !cxt?.constants?.restrictionTypes) return undefined;

        return cxt.constants.restrictionTypes.find(
            (e: RestrictionType) => e.id === type,
        );
    }, [type, cxt?.constants?.restrictionTypes]);

    // Sin tipo resuelto no hay ni rótulo ni color: un chip vacío no dice nada.
    if (!restType) {
        return <></>;
    }

    return (
        <Chip
            size="small"
            style={{ ...chipColors(restType.color) }}
            label={restType.short}
        />
    );
}
